/**
 * Game-related translations for Russian language
 * This file contains translations for game mechanics, stages, and end reasons
 */
export default {
  game: {
    winner: 'Победитель',
    evil: 'тьма',
    good: 'свет',
    stage: 'этап',
    voteStage: 'Этап голосования',
    voting: 'голосование',
    excalibur: 'экскалибур',
    'team building': 'сбор команды',
    mission: 'поход',
    initialization: 'начало',
    'lady of lake': 'леди озера',
    'check loyalty': 'проверка верности',
    'witch loyalty': 'верность ведьмы',
    'announce loyalty': 'объявить верность',
    'give card': 'передать карту',
    'lead to victory': 'привести к победе',
    'restore honor': 'восстанови свою честь',
    'king returns': 'король возвращается',
    'play card': 'сыграть карту',
    'reveal loyalty': 'показать верность',
    'we found you': 'мы нашли тебя',
    ambush: 'засада',
    witch: 'ведьма',
    end: 'конец',
    lancelots: 'ланселоты',
    assassinate: 'убийство',
    hidden: 'скрыто',
    historyMode: 'Режим истории',
    gameIsEnded: 'Игра завершена',
    rolesAndAddons: 'Роли и дополнения',
  },
  endReason: {
    manualy: 'Игра завершена вручную',
    evilTeamMissions: 'Команда сил тьмы провалила 3 похода',
    goodTeamMissions: 'Команда сил света успешно выполнила 3 похода',
    missMerlin: 'Команда сил тьмы пыталась убить Мерлина, но промахнулась',
    missGuinevere: 'Команда сил тьмы пыталась убить Гвиневру, но промахнулась',
    missLovers: 'Команда сил тьмы пыталась убить Любовников, но промахнулась',
    missCleric: 'Команда сил тьмы попыталась убить Клирика + 1, но промахнулась',
    killCleric: 'Команда сил тьмы убила Клирика + 1',
    killGuinevere: 'Команда сил тьмы убила Гвиневру',
    killLovers: 'Команда сил тьмы убила Любовников',
    killMerlin: 'Команда сил тьмы убила Мерлина',
    rejectedVote: 'Команда сил тьмы саботировала голосование',
  },
};
